import { updateDataLayer } from "@utils/updateDataLayer";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { getPaywallType } from "src/appConfig";

const LOCATION_EVENT_MAP = {
  Confirm_email_page_load: "/activate",
  Email_validated_page_load: "/thankyou",
  Login_page_load: "/auth",
  Home_page_load: "/profile",
  "1st_workout_started": "/day-exercises/1",
  PaywallShown: "/paywall",
};

const useLocationEvent = () => {
  const location = useLocation();

  useEffect(() => {
    const currentLocationEvent = Object.entries(LOCATION_EVENT_MAP).find(
      ([eventName, path]) => location.pathname === path
    );

    if (!currentLocationEvent) return;

    const [eventName] = currentLocationEvent;

    const isEventInDataLayer = window.dataLayer?.some(
      (event) => event.event === eventName
    );

    if (!isEventInDataLayer) {
      const payload = { event: eventName };

      if (eventName === "PaywallShown") {
        payload.paywall_name = getPaywallType();
      }

      updateDataLayer(payload);
    }
  }, [location]);
};

export default useLocationEvent;
